import React from 'react';
import { Col, Container, Nav, Navbar, NavDropdown, Row, Button } from 'react-bootstrap';
import { routes } from '../../routes';
import { Link, useHistory } from 'react-router-dom';

const Phonemenu = (props) => {
    let history = useHistory();
    return (
        <>
            <div className="phoneside d-lg-none d-block">
                <div className='container'>
                    <div className='row'>
                        <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0'>
                            <div className='head text-center'>
                                <h6>Techcurizer</h6>
                                <div className='icon-Back'>
                                    <a 
                                onClick={() => {
                                    history.goBack();
                                }}><i className="fas fa-long-arrow-left"></i></a>
                                </div>
                            </div>
                            <div className='profile ps-3'>
                            <Navbar collapseOnSelect >
                                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                                    <Navbar.Collapse id="responsive-navbar-nav">
                                        <Nav className="mr-auto left_area">
                                            <Nav.Item>
                                                <Link to={routes.index}>Home</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.about}>About</Link>
                                            </Nav.Item>
                                            <NavDropdown title="Services" id="collasible-nav-dropdown">
                                                    <NavDropdown className='sub' title="App Development &amp; Management" id="collasible-nav-dropdown1">
                                                        <NavDropdown.Item href={routes.service}>Custom App Development</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Web App Development</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Mobile App Development</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Cross Platform App Development</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Application Maintenance</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Application Modernization</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>eCommerce Development Services</NavDropdown.Item>
                                                    </NavDropdown>

                                                    <NavDropdown className='sub' title="Managed Services" id="collasible-nav-dropdown2">
                                                        <NavDropdown.Item href={routes.service}>IT Strategy &amp; Consulting</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Digital Transformation</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Software Product Development</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Dedicated Teams</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>IT Staff Augmentation</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Quality Assurance</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>DevOps Consulting &amp; Engineering</NavDropdown.Item>
                                                    </NavDropdown>

                                                    <NavDropdown className='sub' title="Data, Analytics &amp; Cloud" id="collasible-nav-dropdown3">
                                                        <NavDropdown.Item href={routes.service}>BI Consulting</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>BI Integration</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>BI Testing</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Big Data</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>AWS Cloud</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Azure Cloud</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>Google Cloud</NavDropdown.Item>
                                                    </NavDropdown>

                                                    <NavDropdown className='sub' title="Other Services" id="collasible-nav-dropdow4">
                                                        <NavDropdown.Item href={routes.service}>BlockChain</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>AI/ML</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>AR &amp; VR</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>IoT</NavDropdown.Item>
                                                        <NavDropdown.Item href={routes.service}>MVP</NavDropdown.Item>
                                                    </NavDropdown>
                                            </NavDropdown>
                                            <Nav.Item>
                                                <Link to={routes.product}>Products</Link>
                                            </Nav.Item> 
                                            <Nav.Item>
                                                <Link to="#">Technologies</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.packages}>Packages</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.verticals}>Verticals</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.hire}>Hire Resources</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.career}>Careers</Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Link to={routes.contact}>Contact Us</Link>
                                            </Nav.Item>
                                        </Nav>
                                    </Navbar.Collapse>
                                </Navbar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}



export default (Phonemenu);
